import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const MENU = [
  { section: 'หลัก' },
  { id: 'dashboard', label: 'Dashboard', icon: 'ti-home', always: true },
  { section: 'คลังสินค้า' },
  { id: 'raw-stock',     label: 'สต็อก Raw Mat',   icon: 'ti-box',           perm: 'can_see_raw_stock' },
  { id: 'restock',       label: 'เติมสต็อก',        icon: 'ti-shopping-cart', page: 'restock' },
  { id: 'bulk-stock',    label: 'สต็อก Bulk',       icon: 'ti-droplet',       perm: 'can_see_bulk_stock' },
  { id: 'finished-stock',label: 'สต็อก Finished',  icon: 'ti-archive',       perm: 'can_see_finished_stock' },
  { id: 'adjust',        label: 'ปรับสต็อก',        icon: 'ti-adjustments',   page: 'adjust' },
  { section: 'การผลิต' },
  { id: 'formulas',      label: 'สูตรน้ำหอม',       icon: 'ti-flask',         perm: 'can_see_formula' },
  { id: 'production',    label: 'สั่งผสม',           icon: 'ti-player-play',  page: 'production' },
  { id: 'bottling',      label: 'บรรจุขวด',         icon: 'ti-package',       page: 'bottling' },
  { section: 'ผู้ดูแล', superadmin: true },
  { id: 'users',         label: 'จัดการ User',      icon: 'ti-users',         superadmin: true },
  { id: 'setup',         label: 'ค่าตั้งต้น',        icon: 'ti-database',      superadmin: true },
  { id: 'audit',         label: 'Audit Trail',      icon: 'ti-clipboard-list',superadmin: true },
];

const PAGE_TITLES = {
  dashboard: 'Dashboard', 'raw-stock': 'สต็อก Raw Material',
  restock: 'เติมสต็อก', 'bulk-stock': 'สต็อก Bulk',
  'finished-stock': 'สต็อก Finished', adjust: 'ปรับสต็อก',
  formulas: 'สูตรน้ำหอม (BOM)', production: 'สั่งผสม',
  bottling: 'บรรจุขวด', users: 'จัดการ User',
  setup: 'ค่าตั้งต้น', audit: 'Audit Trail',
};

export default function Layout({ page, setPage, children }) {
  const { user, logout } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const isSA = user?.role === 'superadmin';

  const canSee = (item) => {
    if (item.always) return true;
    if (item.superadmin) return isSA;
    if (item.perm) return isSA || !!user?.[item.perm];
    return true;
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'var(--bg)' }}>

      {/* ── Sidebar ── */}
      <div style={{
        width: collapsed ? 52 : 200,
        minWidth: collapsed ? 52 : 200,
        background: 'var(--bg-sidebar)',
        borderRight: '1px solid var(--border)',
        display: 'flex', flexDirection: 'column',
        transition: 'width .2s, min-width .2s',
        overflow: 'hidden', flexShrink: 0,
        boxShadow: '1px 0 0 var(--border-light)',
      }}>
        {/* Logo */}
        <div style={{
          padding: collapsed ? '16px 8px' : '16px 16px 14px',
          borderBottom: '1px solid var(--border-light)',
          display: 'flex', alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'space-between',
        }}>
          {!collapsed && (
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary)', letterSpacing: '-.4px' }}>Noirola</div>
              <div style={{ fontSize: 9, color: 'var(--text-label)', marginTop: 2, letterSpacing: '.06em' }}>BOM System</div>
            </div>
          )}
          <button
            onClick={() => setCollapsed(!collapsed)}
            title="ยุบ/ขยายเมนู"
            style={{
              background: 'none', border: 'none',
              color: 'var(--text-muted)', cursor: 'pointer',
              padding: 4, borderRadius: 6, fontSize: 16,
              display: 'flex', alignItems: 'center',
            }}
          >
            <i className="ti ti-menu-2"/>
          </button>
        </div>

        {/* Menu */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '6px 0' }}>
          {MENU.map((item, i) => {
            if (!canSee(item)) return null;
            if (item.section) {
              if (collapsed) return null;
              return (
                <div key={i} style={{
                  fontSize: 9, fontWeight: 700, color: 'var(--text-label)',
                  letterSpacing: '.1em', textTransform: 'uppercase',
                  padding: '10px 16px 4px',
                }}>
                  {item.section}
                </div>
              );
            }
            const active = page === item.id;
            return (
              <button
                key={item.id}
                onClick={() => setPage(item.id)}
                title={collapsed ? item.label : ''}
                style={{
                  display: 'flex', alignItems: 'center',
                  gap: collapsed ? 0 : 8,
                  padding: collapsed ? '8px' : '7px 12px',
                  margin: collapsed ? '1px auto' : '1px 8px',
                  width: collapsed ? 36 : 'calc(100% - 16px)',
                  borderRadius: 10,
                  border: 'none',
                  background: active ? 'var(--accent-bg)' : 'none',
                  color: active ? 'var(--accent)' : 'var(--text-muted)',
                  fontSize: 12, cursor: 'pointer',
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: active ? 600 : 400,
                  justifyContent: collapsed ? 'center' : 'flex-start',
                  whiteSpace: 'nowrap', transition: 'all .15s',
                }}
                onMouseEnter={e => { if (!active) { e.currentTarget.style.background = '#f7f5f2'; e.currentTarget.style.color = 'var(--text-secondary)'; } }}
                onMouseLeave={e => { if (!active) { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = 'var(--text-muted)'; } }}
              >
                <i className={`ti ${item.icon}`} style={{ fontSize: 15, flexShrink: 0 }}/>
                {!collapsed && <span>{item.label}</span>}
              </button>
            );
          })}
        </div>

        {/* User bottom */}
        {!collapsed && (
          <div style={{
            padding: '10px 14px',
            borderTop: '1px solid var(--border-light)',
            display: 'flex', alignItems: 'center', gap: 8,
          }}>
            <div style={{
              width: 28, height: 28, borderRadius: '50%',
              background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 10, fontWeight: 700, color: '#fff', flexShrink: 0,
            }}>
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <div style={{ flex: 1, overflow: 'hidden' }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-primary)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name}</div>
              <div style={{ fontSize: 9, color: 'var(--text-label)' }}>{user?.role}</div>
            </div>
            <button
              onClick={logout}
              title="ออกจากระบบ"
              style={{ background: 'none', border: 'none', color: 'var(--text-label)', cursor: 'pointer', fontSize: 15, display: 'flex', alignItems: 'center' }}
            >
              <i className="ti ti-logout"/>
            </button>
          </div>
        )}
      </div>

      {/* ── Main ── */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {/* Topbar */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '12px 22px',
          background: 'var(--bg-topbar)',
          borderBottom: '1px solid var(--border)',
          flexShrink: 0,
        }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary)', letterSpacing: '-.3px' }}>
            {PAGE_TITLES[page] || page}
          </div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
            {user?.username}
          </div>
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '18px 22px' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
